/*
 * Inntoning ved rulling er slaatt av med vilje.
 *
 * Dawn gir hvert element klassen `scroll-trigger`, setter det til opacity 0
 * og avdekker det med en IntersectionObserver. Observatoeren settes opp én
 * gang, paa DOMContentLoaded. Alt som kommer inn i sida **etterpaa** blir
 * derfor aldri observert, blir aldri avdekket, og staar usynlig for alltid.
 *
 * Det rammet tre steder i denne butikken:
 *   - anbefalingsraden «Du vil kanskje ogsaa like», som hentes med AJAX
 *   - produktgalleriet, der bilder ble staaende blanke
 *   - rutenett som tegnes paa nytt ved filtrering og sortering
 *
 * Kortene laa der hele tiden, i HTML-en, med gyldige filer. De var bare
 * usynlige. Derfor fjernes utloeserklassene i stedet: da gjelder ingen av
 * animasjonsreglene, og alt vises med en gang.
 *
 * Zoom-effekten er beholdt. Den skjuler ingenting, den skalerer bare.
 */

const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function revealAll(rootEl) {
  const root = rootEl || document;
  if (!root.getElementsByClassName) return 0;
  // Live HTMLCollection: ta en kopi foerst, ellers krymper lista mens vi
  // fjerner klassen og annenhvert element hoppes over.
  const elements = Array.from(root.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  elements.forEach((element) => {
    element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    element.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
  });
  return elements.length;
}

function initializeScrollAnimationTrigger(rootEl = document) {
  revealAll(rootEl);
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

function watchForLateSections() {
  if (!window.MutationObserver) return;
  let queued = false;
  const run = () => {
    queued = false;
    revealAll(document);
  };
  new MutationObserver(() => {
    // Aa fjerne en klasse er i seg selv en endring. Uten denne koen ville
    // observatoeren utloese seg selv; med den stanser det etter ett pass,
    // fordi andre runde ikke finner noe aa fjerne.
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }).observe(document.documentElement, { childList: true, subtree: true });
}

revealAll(document);

window.addEventListener('DOMContentLoaded', () => {
  revealAll(document);
  watchForLateSections();
  initializeScrollZoomAnimationTrigger();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => revealAll(event.target));
  document.addEventListener('shopify:section:reorder', () => revealAll(document));
}
